import React, { useState } from "react";
import "./SearchMenu.scss";
import { Link } from "@StarberryUtils"
// import PlayVideo from "../../Components/Play/PlayVideo";
import Slider from "react-slick";

import { ShowProcessedImage } from '../common/ggfx-client/module/components/show-image';
import ImageTransform from "../common/ggfx-client/module/components/image-transform"
import FloorPlanModal from "../SearchResult/floorPlanModal";
import VideoPlay from "../Play/property-results-video";
import imageConfig from "../../../static/images/config.json"
import PriceComp from "@components/Property/Price"

import Soon from "../../images/coming-soon.png"

const SearchList = (props) => {
  let [isPlay, setPlay] = useState(false);

  const settings = {
    dots: true,
    speed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    arrows: true,
    mobileFirst: true,
    autoplay: false,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 1402,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },

      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 377,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const [isOpen, setIsOpen] = useState(false); 
  return (
    <React.Fragment>
        <div className="wrapper">
            <div className="search-img-wrapper">
              <Link className="search-img-link" to={props.link}>
              <Slider className="slick-arrow" {...settings}>
                {props.images?.map((image, i) => {
                    if (i > 2) return null;

                let processedImages = JSON.stringify({});
                  if (props?.imagetransforms?.images_Transforms) {
                      processedImages = props.imagetransforms.images_Transforms;
                  }
                  var imgUrl = image.url;
                  var loadUrl = "";
                  if(imgUrl?.includes("property_feed_full")) {
                    loadUrl = imgUrl.split('%')
                  }
                 var imageName = "property.images.similar_properties";
                  if(props?.listName === "international"){
                    imageName = "international-property.images.similar_properties";
                  }
                  return (
                  <div className="slide-img img-zoom">
                  {(props?.source && props.source === 'strapi') ? (
                    <ImageTransform imagesources={image.url} renderer="srcSet" imagename={imageName} attr={{ alt: props.display_address+ ' - Redbrik', class:'' }} imagetransformresult={processedImages} id={props._id}/>
                  ) :(loadUrl.length>0 ?
                     <img alt={"image place"} src={loadUrl[0]} loading="lazy"/> :
                     <ShowProcessedImage images={image} attr={{ className: 'mb-0 img-fluid', alt: ''}} transforms={imageConfig.property.searchResults2.sizes} />
                  )}
                  </div>
                  )
                })}
                {(props.images === null || (props?.images && props.images.length === 0)) &&
                  <div className="slide-img img-zoom">
                    <img src={Soon} className='no-image mb-0 img-fluid' alt="" />
                  {/* <ShowProcessedImage images={image} attr={{ className: 'mb-0 img-fluid', alt: ''}} transforms={imageConfig.property.searchResults2.sizes} />  */}
                  </div>
                }
              </Slider>
              </Link>
              <div className="video-tour"> 
                  <>
                  {props.photoplans == true ? <a href={props.virtual_tour} target="_blank" className="photoplan"><span className="play-btn"><i className="icon-play"></i></span></a> :
                  <>{(props.virtual_tour ? ((props.virtual_tour.length > 0) ? <VideoPlay url={props.virtual_tour}/> : ''):'')}</>
                  }
                  </>
              </div>
              <div className="search-img-overlay">
                  {props.floorplan && JSON.stringify(props.floorplan) !== '[]' ? <FloorPlanModal floorplanimg={props.floorplan.url} /> : ''} 
              </div>
              {props.status === "Sold STC" ? <div className="flag">SOLD STC</div> : ''}
              {props.status === "Let Agreed" ? <div className="flag">LET AGREED</div> : ''}
              {props.status === "sold" ? <div className="flag">SOLD</div> : ''}
              {props.status === "let" ? <div className="flag">LET</div> : ''}
          </div>
          <div className="slide-img-content">
          {/* <Link href="javascript:void(0)" >
            <i className="icon-play "   onClick={(e) => {
                      setPlay(true);
                    }
                  }></i>
          </Link>

          <Link href="javascript:void(0)">
            <i className="icon-floor"></i>
          </Link> */}
        </div>
        </div>
        <div className="card-details">
          <h3>
            {props.link ?
            <Link to={props.link}>{props.Title}</Link> :
            <>{props.Title}</>
            }
            </h3>
            {props.priceDetails &&
          <h4>
            <PriceComp {...props} />
          </h4>
          }
          <div className="card-info">
           {/*props.buildingType &&
            <span className="details building"> 
              {props.buildingType.replace(/-/g, " ")}
            </span>
           */}
            {props.bedroom && props.bedroom>0 &&
            <span className="details">
              <span className="room-icon">
                <i className="icon-chair"></i>
              </span>
              {props.bedroom}
            </span>
            }
            {props.bathroom && props.bathroom > 0 && 
            <span className="details">
              <span className="room-icon">
                <i className="icon-bathroom"></i>
              </span>
              {props.bathroom}
            </span>
            }
            {props.reception && props.reception>0 &&
            <span className="details">
              <span className="room-icon">
                <i className="icon-bedroom"></i>
              </span>
              {props.reception}
            </span>
            }
          </div>
          {props.description &&
            <p>{props.description.slice(0,200)}... <Link className="more-link" to={props.link}>more</Link></p>
          }
        </div>
        {/* <PlayVideo
          key={props.unique_key}
          isOpen={isPlay}
          isCloseFunction={setPlay}
          videoId={props.videoid}
          isAutoPlay={1}
        /> */}
    </React.Fragment>
  );
};

export default SearchList;
